import { combineReducers, Reducer } from "@reduxjs/toolkit";
import personDetailsReducer from "./personalDetailsReducer";
import submitReducer from "./submitReducer";
import subscriptionDetailsReducer from "./subscriptionDetailsReducer";
import { FORM_ID } from "../../../../constants";
import { createReducer as createFormsReducer } from "../../rapidform";

const reducer: Reducer = combineReducers({
    isOrderFound: (state = false) => state,
    isOrderSubmitable: (state = false) => state,
    newLegalOwner: (state = { orgName: "", orgNumber: "" }) => state,
    personalDetails: personDetailsReducer,
    subscriptionDetails: subscriptionDetailsReducer,
    submit: submitReducer,
    [FORM_ID.ONBOARDING_EMAIL]: createFormsReducer(FORM_ID.ONBOARDING_EMAIL),
});

export default reducer;
